import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const API_URL = `${BASE_URL}/nomina/empleado/reporte`;

export const obtenerReporteIndividualPdf = async (id) => {
    const token = localStorage.getItem('jwt')?.replaceAll('"', '') || '';
    
    const response = await axios.get(`${API_URL}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob' // CRÍTICO: Para manejar archivos binarios
    });
    
    return response.data;
};

export const obtenerReporteGeneralPdf = async () => {
    const token = localStorage.getItem('jwt')?.replaceAll('"', '') || '';
    
    const response = await axios.get(`${API_URL}/general`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
    });
    
    return response.data;
};